<div class="container mx-auto md:text-base text-sm">
  <div class="mt-8 text-center">
    <h1 class="font-['Apex_Rounded_Medium'] lg:text-3xl text-xl md:w-4/5 w-full mx-auto"> 
   
      {{ "customerAssignmentMissing" | translate:{ firstName: user().familyName, lastName: user().givenName} }}
    </h1>
  </div>


  <div class="flex text-center">
    <img src="assets/ACP-Error-bot_warning.webp" alt="Image of a sad face" class="mx-auto w-full sm:w-1/2" />
  </div>

  <!-- Buttons section -->
  <div class="mt-8 gap-4 justify-center text-center">
    <!-- FAQ + countdown -->
    <div class="flex justify-center gap-4">
      <p-button [label]="'faq' | translate" severity="primary" styleClass="md:w-40 w-auto md:text-base text-sm"
        (click)="redirectToFaq()">
      </p-button>
      <p-button [label]="'menu.logOut' | translate" severity="secondary" styleClass="md:w-40 w-auto md:text-base text-sm"
        (click)="logout()">
      </p-button>

    </div>


    <!-- Logout button -->
    <div>
      <p class="mt-3 md:text-base text-sm">
        {{ 'redirectCountdown' | translate:{ seconds: countdown } }}
      </p>
    </div>

    <!-- Technical Details section -->
    <div class="mt-4 mx-auto max-w-md lg:fixed lg:right-4 lg:bottom-4 lg:w-80 lg:max-w-none lg:mx-0 lg:mt-0 bg-white border border-gray-200 shadow-lg rounded-lg">
      <!-- Header with title and copy icon -->
      <div class="bg-gray-50 px-4 py-3 border-b flex items-center justify-between rounded-t-lg">
        <h3 class="font-['Apex_Rounded_Medium'] text-sm font-semibold text-gray-800">
          {{ 'technicalDetails' | translate }}
        </h3>
        <a class="icon-with-circle !m-0" 
           (click)="$event.stopPropagation(); copyTitle()"
           [title]="copied() ? ('copiedToClipboard' | translate) : ('copyAllDetailsToClipboard' | translate)">
          <i class="pi" [ngClass]="copied() ? 'pi-check' : 'pi-copy'"></i>
        </a>
      </div>
      
      <!-- Table content -->
      <div class="p-3">
        <table class="w-full text-sm">
          <tbody>
            <tr>
              <td class="py-1 pr-1 text-gray-500 text-xs uppercase tracking-wide font-medium w-1/3 text-left">
                {{ 'name' | translate }}
              </td>
              <td class="py-1 text-gray-900 font-medium text-left">
                {{ user().familyName }}, {{ user().givenName }}
              </td>
            </tr>
            
            <tr>
              <td class="py-1 pr-1 text-gray-500 text-xs uppercase tracking-wide font-medium w-1/3 text-left">
                {{ 'email' | translate }}
              </td>
              <td class="py-1 text-gray-900 text-left break-all">
                {{ user().email }}
              </td>
            </tr>
            
            <tr>
              <td class="py-1 pr-1 text-gray-500 text-xs uppercase tracking-wide font-medium w-1/3 text-left">
                {{ 'userId' | translate }}
              </td>
              <td class="py-1 text-gray-900 font-mono text-xs text-left whitespace-nowrap overflow-hidden">
                {{ user().subject }}
              </td>
            </tr>
            
            <tr>
              <td class="py-1 pr-1 text-gray-500 text-xs uppercase tracking-wide font-medium w-1/3 text-left">
                {{ 'provider' | translate }}
              </td>
              <td class="py-1 text-gray-900 text-left">
                {{ user().provider }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </div>
  </div>